import api from "./api";

export const siteInformationService = {
  getByReport: async (siteId, reportId) => {
    const response = await api.get(`/site-information/${siteId}/${reportId}`);
    return response.data;
  },

  upsertByReport: async (siteId, reportId, payload) => {
    const response = await api.put(`/site-information/${siteId}/${reportId}`, payload);
    return response.data;
  },
};
